import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CustomTextField from '../common/custom-components/customTextField';
import PropTypes from 'prop-types';
import {
  required,
  number,
  code,
  password,
  passwordsMustMatch,
  PassRequired,
  PASSWORD_POLICY,
} from '../../constants/constants';
import InfoMessageBar from '../common/info-message/info-message';
import Card from '@material-ui/core/Card';
import './reset-password.css';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
export const ResetPasswordConfirmForm = ({
  errors,
  handleSubmit,
  invalid,
  submitting,
  pristine,
}) => {
  return (
    <div className="auth-page" style={{ backgroundColor: '#F7F8F9' }}>
      <div className="container page">
        <div className="row">
          <div className="col-md-6 offset-md-3 col-xs-12">
            <Card style={{ padding: 60 }}>
              {errors && (
                <InfoMessageBar
                  icColor="errorIc"
                  variant="error"
                  message={errors}
                />
              )}
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <CardContent>
                  <Typography
                    variant="h4"
                    className="text-xs-center"
                    color="primary"
                    gutterBottom
                    style={{ fontFamily: 'SerifaStd - Roman' }}
                  >
                    Reset Password
                  </Typography>
                  <Typography
                    variant="body2"
                    component="p"
                    className="text-xs-center"
                  >
                    Please enter the information below to reset your password.
                  </Typography>

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="newPassword"
                    symbol="Password"
                    placeholder="New Password"
                    required
                    fullWidth
                    type="password"
                    validate={[PassRequired, password]}
                    variant="outlined"
                  />
                  <Box
                    component="div"
                    m={1}
                    color="text.primary"
                    style={{ border: '1px solid black', padding: 28 }}
                  >
                    <Typography
                      variant="body1"
                      component="p"
                      className="text-xs-center"
                    >
                      {PASSWORD_POLICY}
                    </Typography>
                  </Box>
                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="passwordConfirm"
                    symbol="Confirm Password"
                    placeholder="Confirm Password"
                    required
                    fullWidth
                    type="password"
                    validate={[PassRequired, password, passwordsMustMatch]}
                    variant="outlined"
                  />
                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="code"
                    symbol="Code"
                    placeholder="Confirmation Code"
                    required
                    fullWidth
                    type="text"
                    validate={[required, number, code]}
                    variant="outlined"
                  />
                </CardContent>
                <div className="botton-group-reset">
                  <Button
                    className="btn btn-lg  pull-xs-right"
                    disabled={invalid || submitting || pristine}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{ padding: '15px 120px', borderRadius: 28 }}
                  >
                    RESET PASSWORD
                  </Button>
                  <div className="link-pad-reset">
                    <Link
                      to="/login"
                      style={{
                        fontSize: 20,
                        fontFamily: 'Arial',
                        textAlign: 'center',
                        align: 'center',
                      }}
                    >
                      CANCEL
                    </Link>
                  </div>
                </div>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

ResetPasswordConfirmForm.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  invalid: PropTypes.func,
  submitting: PropTypes.func,
  pristine: PropTypes.func,
};

export default reduxForm({
  form: 'resetPasswordConfirmForm',
  // a unique identifier for this form
})(ResetPasswordConfirmForm);
